import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { ControlCrane } from "../../services/controlCrane.service";
import { Router } from "@angular/router";
import { EJComponents } from "ej-angular2/src/ej/core";
import { AppStateService } from "../../services/appState.service";
import * as allgemeineFunktionen from "../../allgemeinesTS_CSS/allgemeineHilfsfunktionen";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-crane-setup",
  template: "Not of use ...",
  providers: [ControlCrane],
})
export class ControlAllgemeinComponent implements OnInit {
  @ViewChild("OWWinkelInput") formOWWinkelInput: ElementRef;
  @ViewChild("RadiusInput") formRadiusInput: ElementRef;
  @ViewChild("HAWinkelInput") formHAWinkelInput: ElementRef;
  @ViewChild("LastInput") formLastInput: ElementRef;
  protected initialisiereKran = false;
  protected ladeKran = false;
  protected aktualisiereAnzeige = false;
  protected ergebnisseAktualisieren = false;
  protected MAXWerteAktualisieren = false;
  protected kranZustandAendern = false;
  protected ruestdatenAktualisieren = false;
  //  protected haAusfahrfolgeGeklaert = false;
  public haSelect_disabled = false;
  public gewichtsEinheit = "t";
  public laengenEinheit = "m";
  public grafikBasis = "deps/images/";
  public modelGraphicsPath = "CraneConfigurationDrawings/SVG/";
  public kranmodell = "no_matching_pic_found.svg";
  public hiFeldTyp = "";
  protected kranDatenbankNamen: string;
  protected kranPointer: string;
  public kranname = "";
  public Kombination = "";
  public HAWinkel: string;
  public OWWinkel: string;
  protected initWinkel = false;
  public Radius: string;
  protected maxRadius = 0;
  public translate = "translate(0px,0px)";
  public AuslegerStrichLaenge = "0px";
  public AuslegerStrichRotation = "rotate(0deg)";
  protected maxVersatz = 55; // Wert zur Berechnung der Position des Lastmarkers. Gibt den Durchmesser der 'Anzeige' an.
  public gegengewichte: number[] = [];
  public aktuellesGegengewicht: number;
  public haLaengen: string[] = [];
  public passendeHAAusfahrfolgen = {};
  protected hi1Laenge: number;
  protected hi1Winkel: string;
  protected hi1MinWinkel: number;
  protected hi1MaxWinkel: number;
  protected moeglicheHi1Winkel: string[] = [];
  protected hiAsMbExtension: boolean;
  public AdapterLaenge: string;
  protected HIWinkelString: string;
  protected aktuelleHALaenge: string;
  protected aktuelleHAAusfahrfolge: string;
  public Last = "0";
  public RollenkopfHoehe: number;
  public Auslastung: number;
  public Maxload: number;
  protected auslegerfall: string;
  public stuetzeVL = "";
  public stuetzeVR = "";
  public stuetzeHL = "";
  public stuetzeHR = "";
  public actHintenRechts: string; // Stuetzlast hinten rechts
  public actHintenLinks: string; // Stuetzlast hinten links
  public actVorneRechts: string; // Stuetzlast vorne rechts
  public actVorneLinks: string; // maximale Stuetzlast vorne links
  public maxHintenRechts: string; // maximale Stuetzlast hinten rechts
  public maxHintenLinks: string; // maximale Stuetzlast hinten links
  public maxVorneRechts: string; // maximale Stuetzlast vorne rechts
  public maxVorneLinks: string; // maximale Stuetzlast vorne links
  public description = "";
  public abstuetzungProzent = {
    stuetzeVL: "0",
    stuetzeVR: "0",
    stuetzeHL: "0",
    stuetzeHR: "0",
  };
  public auslastungsAnzeige = "";
  // Fehlerbehandlung/-anzeige
  public FehlerUeberschrift = "";
  public FehlerHinweis = "";
  public FehlerCallback: Function;
  public zeigeFehlerMeldung = false;
  // Steuerung von Funktionen
  protected aendereWerte: any[] = []; // diverse Timer;
  // Steuerung der Ausführung von abhängigen Aufgaben
  protected owWinkelGesetzt = false;
  protected radiusGesetzt = false;
  protected lastGesetzt = false;
  protected berechnungAn = false;
  protected tempLast: string;
  protected tempRadius: string;
  protected HAWerteFuerNeueHALaenge: Object;
  protected stellenNachEinheitenSystem: number;
  // Variablen fuer div- Dialoge
  public zeigeDialog = false; // soll ein Dialog angezeigt werden?
  public dialogHTML: any; // HTML Code des Dialogs
  // Variablen für die Suche nach kompatiblen Kranen
  public sichtbarkeitUmruestung: number;
  public UmruestenTooltip = "not available";
  protected kompatiblerKran: object;

  constructor(
    private craneControlServiceSuper: ControlCrane,
    private routerSuper: Router,
    private appStateServiceSuper: AppStateService,
    private sanitizerSuper: DomSanitizer
  ) {}
  ngOnInit() {}
  initComponent() {
    if (
      this.appStateServiceSuper.aktuellerAppStatus["einheitenSystem"] === "M"
    ) {
      this.stellenNachEinheitenSystem = 2;
    } else {
      this.stellenNachEinheitenSystem = 1;
    }
    if (
      this.appStateServiceSuper.aktuellerAppStatus["kranname"] !== undefined
    ) {
      this.kranname = this.appStateServiceSuper.aktuellerAppStatus["kranname"];
    }
    this.initialisiereKran = true;
    this.kranDatenbankNamen =
      this.appStateServiceSuper.aktuellerAppStatus["kranDatenbankNamen"];
    this.kranPointer = this.appStateServiceSuper.aktuellerAppStatus["pointer"];
    this.OWWinkel = this.appStateServiceSuper.aktuellerAppStatus["owWinkel"];
    this.description =
      this.appStateServiceSuper.aktuellerAppStatus["KurzBeschreibung"] !==
      undefined
        ? this.appStateServiceSuper.aktuellerAppStatus["KurzBeschreibung"]
        : "";
    if (this.OWWinkel === "" || this.OWWinkel === undefined) {
      this.OWWinkel = "initOWWinkel";
    }
    if (
      this.appStateServiceSuper.aktuellerAppStatus["owWinkel"] !== "" ||
      this.appStateServiceSuper.aktuellerAppStatus["owWinkel"] !== undefined
    ) {
      this.initWinkel = true;
    }
    this.ladeKran = true;
    this.aktualisiereAnzeige = true;
    this.tempLast = this.appStateServiceSuper.aktuellerAppStatus["RHLLast"];
    this.tempRadius = this.appStateServiceSuper.aktuellerAppStatus["RHLRadius"];
    let spiegeln =
      this.appStateServiceSuper.aktuellerAppStatus["seitenSpiegeln"];
    if (spiegeln === "" || spiegeln === undefined) {
      spiegeln = false;
    }
    this.craneControlServiceSuper
      .erzeugeKran(this.kranDatenbankNamen, this.kranPointer, spiegeln, false)
      .then((res) => {
        this.owWinkelAendern(this.OWWinkel);
        this.aktualisiereAnzeige = true;
        this.ladeKran = false;
        this.initialisiereKranDaten();
      });
  }
  initialisiereKranDaten() {
    if (this.tempRadius !== "" && this.tempRadius !== undefined) {
      this.initialisiereRadius();
    } else {
      this.radiusGesetzt = true;
    }
    if (this.tempLast !== "" && this.tempLast !== undefined) {
      this.initialisiereLast();
    } else {
      this.lastGesetzt = true;
    }
    this.holeInitialeDaten();
  }
  initialisiereRadius() {
    if (this.aendereWerte["initialisiereRadius"] !== undefined) {
      clearTimeout(this.aendereWerte["initialisiereRadius"]);
    }
    this.aendereWerte["initialisiereRadius"] = setTimeout(() => {
      if (this.owWinkelGesetzt === true) {
        this.radiusAendern(this.tempRadius);
      } else {
        this.initialisiereRadius();
      }
    }, 200);
  }
  initialisiereLast() {
    if (this.aendereWerte["initialisiereLast"] !== undefined) {
      clearTimeout(this.aendereWerte["initialisiereLast"]);
    }
    this.aendereWerte["initialisiereLast"] = setTimeout(() => {
      if (this.radiusGesetzt === true) {
        this.lastAendern(this.tempLast);
      } else {
        this.initialisiereLast();
      }
    }, 200);
  }
  holeInitialeDaten() {
    this.pruefeAufKompatiblenTabellenKran();
  }
  holeRuestdaten() {
    this.ruestdatenAktualisieren = true;
    this.craneControlServiceSuper
      .holeRuestdaten()
      .then((res) => this.einlesenRuestdaten(res));
  }
  holeErgebnisse() {
    this.ergebnisseAktualisieren = true;
    this.craneControlServiceSuper
      .holeErgebnisse()
      .then((res) => this.einlesenErgebnisse(res));
  }
  holeMAXWerte() {
    this.MAXWerteAktualisieren = true;
    this.craneControlServiceSuper.holeMAXWerte().then((res) => {
      this.maxRadius = res["maxRadius"];
      this.MAXWerteAktualisieren = false;
      this.lastMarkerSetzen();
    });
  }

  owWinkelAendern(e: string = "") {
    if (this.aendereWerte["owWinkelAendern"] !== undefined) {
      clearTimeout(this.aendereWerte["owWinkelAendern"]);
    }
    e = allgemeineFunktionen.kommaInPunkt(e);
    if (isNaN(Number(e)) && e !== "initOWWinkel") {
      this.zeigeFehler(
        "Incorrect value",
        "The value entered is not at number, please enter a number value.",
        () => {
          this.formOWWinkelInput.nativeElement.value = this.OWWinkel;
        }
      );
    } else {
      this.aendereWerte["owWinkelAendern"] = setTimeout(() => {
        this.owWinkelGesetzt = false;
        if (e === "") {
          e = String(this.OWWinkel);
          this.OWWinkel = e;
        }
        if (
          e === "initOWWinkel" ||
          this.initWinkel === true ||
          parseFloat(e) !== parseFloat(this.OWWinkel)
        ) {
          this.initWinkel = false;
          this.aktualisiereAnzeige = true;
          this.craneControlServiceSuper.aendereOWWinkel(e).then((res) => {
            // Winkelanpassung Grove
            if (res["OWGedreht"] > 180) {
              res["OWGedreht"] = allgemeineFunktionen.rundeZahl(
                res["OWGedreht"] - 360,
                2
              );
            }
            while (parseFloat(e) > 180) {
              e = String(
                allgemeineFunktionen.rundeZahl(parseFloat(e) - 360, 2)
              );
            }
            if (res["OWGedreht"] !== parseFloat(e) && e !== "initOWWinkel") {
              this.zeigeFehler(
                "Angle not possible",
                "The selected angle is not available for this configuration.\nSettings will be reset.\nPossible slew angles: " +
                  res["erlaubteDrehbereiche"],
                () => {
                  this.OWWinkel = "reset";
                  this.OWWinkel = res["OWGedreht"];
                  this.appStateServiceSuper.appStatusSetzen({
                    owWinkel: String(res["OWGedreht"]),
                  });
                }
              );
            }
            this.aktualisiereAnzeigeFelder(res);
            this.appStateServiceSuper.appStatusSetzen({
              owWinkel: res["OWGedreht"],
            });
            this.lastMarkerSetzen();
            this.owWinkelGesetzt = true;
            this.pruefeAufKompatiblenTabellenKran();
          });
        }
      }, 100);
    }
  }
  aktualisiereAnzeigeFelder(res) {
    this.einlesenErgebnisse(res);
    this.einlesenRuestdaten(res);
    this.aktualisiereAnzeige = false;
  }
  einlesenErgebnisse(res) {
    this.actVorneLinks = res["VL"];
    this.actVorneRechts = res["VR"];
    this.actHintenLinks = res["HL"];
    this.actHintenRechts = res["HR"];
    this.maxVorneLinks = res["VLmax"];
    this.maxVorneRechts = res["VRmax"];
    this.maxHintenLinks = res["HLmax"];
    this.maxHintenRechts = res["HRmax"];
    this.Maxload = res["MaxLoad"];
    this.Auslastung = res["Auslastung"];
    this.auslastungsAnzeige =
      "LiftplanII/Kransteuerung/kranSteuerung.php?action=erzeugeLastanzeige&genutzterBereich=" +
      this.Auslastung +
      "&maxSizeX=195&maxSizeY=41";
    this.ergebnisseAktualisieren = false;
  }
  einlesenRuestdaten(res) {
    // Winkel auf Grove anpassen.
    this.OWWinkel = "reset";
    if (res["OWWinkel"] > 180) {
      this.OWWinkel = allgemeineFunktionen
        .rundeZahl(res["OWWinkel"] - 360, 2)
        .toString();
    } else {
      this.OWWinkel = String(res["OWWinkel"]);
    }
    this.HAWinkel = res["HAWinkel"];
    this.Radius = res["Radius"];
    this.appStateServiceSuper.appStatusSetzen({ RHLRadius: this.Radius });
    this.RollenkopfHoehe = res["Rollenkopfhoehe"];
    this.Last = res["aktuelleLast"];
    this.appStateServiceSuper.appStatusSetzen({ RHLLast: this.Last });
    this.Kombination = res["Kombination"];
    this.haLaengen = [];
    this.aktuelleHALaenge = res["HALaenge"];
    if (res["HALaengen"] === undefined) {
      this.haLaengen.push(res["HALaenge"]);
    } else {
      for (const HALaenge of res["HALaengen"]) {
        this.haLaengen.push(HALaenge);
      }
      if (!this.haLaengen.includes(this.aktuelleHALaenge.toString())) {
        // der aktuelle HA ist wohl in überlast, daher nicht mehr in der Liste. Also sortieren wir ihn rein.
        let z = 0;
        while (
          z <= this.haLaengen.length - 1 &&
          parseFloat(this.aktuelleHALaenge) > parseFloat(this.haLaengen[z])
        ) {
          z++;
        }
        this.haLaengen.splice(z, 0, this.aktuelleHALaenge);
      }
    }
    // Doppelte HALaengen entfernen
    this.haLaengen = allgemeineFunktionen
      .arrayUnique(this.haLaengen)
      .sort(function (a, b) {
        return a - b;
      });
    this.aktuelleHAAusfahrfolge = res["HAAusfahrf"];
    this.hi1Laenge = res["HI1Laenge"];
    this.SetHi1Winkel(res["HI1Winkel"]);
    this.hi1MinWinkel = res["HI1MinWinkel"];
    this.hi1MaxWinkel = res["HI1MaxWinkel"];
    this.moeglicheHi1Winkel = [];
    if (res["moeglicheHi1Winkel"] !== undefined) {
      for (const hiW of res["moeglicheHi1Winkel"]) {
        this.moeglicheHi1Winkel.push(hiW);
      }
    } else {
      this.moeglicheHi1Winkel.push(this.hi1Winkel);
    }
    this.hiAsMbExtension = res["HiAsMbExtension"];
    this.gegengewichte = [];
    this.aktuellesGegengewicht = res["Gegengewicht"];
    this.gegengewichte.push(res["Gegengewicht"]);
    // Feststellen welcher Ausleger wippbar ist und wie.
    this.auslegerfall = res["Auslegerfall"];
    // passende HAAusfahrfolgen zusammen fassen und ablegen.
    this.passendeHAAusfahrfolgen = [];
    if (res["passendeHAAusfahrf"] !== undefined) {
      for (const passendeFolge in res["passendeHAAusfahrf"]) {
        if (res["passendeHAAusfahrf"].hasOwnProperty(passendeFolge)) {
          const schluessel = this.rundeHAWerte(
            passendeFolge,
            this.stellenNachEinheitenSystem
          );
          if (!this.passendeHAAusfahrfolgen.hasOwnProperty(schluessel)) {
            this.passendeHAAusfahrfolgen[schluessel] = [];
          }
          for (const einzelneFolge of res["passendeHAAusfahrf"][
            passendeFolge
          ]) {
            this.passendeHAAusfahrfolgen[schluessel].push(einzelneFolge);
          }
        }
      }
    }
    if (res["AdapterLaenge"] !== undefined)
      this.AdapterLaenge = res["AdapterLaenge"];
    if (res["HIWinkelString"] !== undefined)
      this.HIWinkelString = res["HIWinkelString"];

    //-------------------------------------------------
    // get graphics of crane for control setup
    const combinationLower = this.Kombination.toLocaleLowerCase();
    switch (this.auslegerfall) {
      case "HI_frei":
      case "HI2_frei":
      case "HI3_frei":
        this.hiFeldTyp = "HI_frei";
        // BT_10, BT_138
        if (combinationLower.includes("mwl")) {
          this.kranmodell = "BT_138.svg";
        } else {
          this.kranmodell = "BT_10.svg";
        }
        break;
      case "HIs_fest":
      case "HI_zwischenwinkel":
      case "HI2_zwischenwinkel":
      case "HI3_zwischenwinkel":
        this.hiFeldTyp =
          this.auslegerfall === "HIs_fest" ? "HIs_fest" : "HI_zwischenwinkel";
        // BT_1, BT_2, BT_6, BT_9, BT_133, BT_137
        if (combinationLower.includes("fj")) {
          if (this.hiAsMbExtension) {
            this.kranmodell = "BT_1.svg";
          } else {
            this.kranmodell = "BT_2.svg";
          }
        } else if (combinationLower.includes("hdj")) {
          if (this.hiFeldTyp === "HIs_fest") {
            if (combinationLower.includes("mwl")) {
              this.kranmodell = "BT_133.svg";
            } else {
              this.kranmodell = "BT_5.svg";
            }
          } else {
            this.kranmodell = "BT_6.svg";
          }
        } else if (combinationLower.includes("mwl")) {
          if (
            combinationLower.includes("_") &&
            combinationLower
              .substring(combinationLower.lastIndexOf("_") + 1)
              .match(/[\d]+[\.,][\d]+[m(ft)]{1}/) !== null
          ) {
            this.kranmodell = "BT_137.svg";
          } else {
            this.kranmodell = "BT_133.svg";
          }
        } else if (combinationLower.includes("sa")) {
          if (this.hiAsMbExtension) {
            this.kranmodell = "BT_1.svg";
          } else {
            this.kranmodell = "BT_11.svg";
          }
        } else {
          if (
            combinationLower.includes("_") &&
            combinationLower
              .substring(combinationLower.lastIndexOf("_") + 1)
              .match(/[\d]+[\.,][\d]+[m(ft)]{1}/) !== null
          ) {
            if (this.hiAsMbExtension) {
              this.kranmodell = "BT_1.svg";
            } else {
              if (
                this.AdapterLaenge !== undefined &&
                this.AdapterLaenge !== null
              ) {
                this.kranmodell = "BT_9.svg";
              } else {
                this.kranmodell = "BT_2.svg";
              }
            }
          } else {
            if (this.hiAsMbExtension) this.kranmodell = "BT_9.svg";
            else this.kranmodell = "BT_2.svg";
          }
        }
        break;
      case "Ausleger_fest_mit_Katze":
        break;
      case "Ausleger_frei_wippbar":
        break;
      case "Ausleger_wippbar_mit_Katze":
        break;
      case "Fehler":
        break;
      case "Last_amHA":
      case "nur_HA":
      default: // BT_0, BT_100, BT_128
        // BT_0 und BT_100 sind gleich
        if (combinationLower.includes("mwl")) {
          this.kranmodell = "BT_128.svg";
        } else {
          // BT_0 is the same
          this.kranmodell = "BT_100.svg";
        }
        this.hiFeldTyp = "KeinHI";
        break;
    }
    //-------------------------------------------------
    this.ruestdatenAktualisieren = false;
  }
  SetHi1Winkel(hiWinkel: string) {
    this.hi1Winkel = hiWinkel;
  }
  lastAendern(e: string) {
    if (this.aendereWerte["lastAendern"] !== undefined) {
      clearTimeout(this.aendereWerte["lastAendern"]);
    }
    e = allgemeineFunktionen.kommaInPunkt(e);
    if (isNaN(Number(e))) {
      this.zeigeFehler(
        "Incorrect value",
        "The value entered is not at number, please enter a number value.",
        () => {
          this.formLastInput.nativeElement.value = this.Last;
        }
      );
    } else {
      this.aendereWerte["lastAendern"] = setTimeout(() => {
        this.lastGesetzt = false;
        if (e === "") {
          e = String(this.Last);
          this.Last = e;
        } else {
          e = allgemeineFunktionen.kommaInPunkt(e);
        }
        if (parseFloat(e) !== parseFloat(this.Last)) {
          let aktuelleLast = this.Last;
          //          if (this.Maxload === undefined) {
          //            return;
          //          }
          this.aktualisiereAnzeige = true;
          this.craneControlServiceSuper
            .aendereLast(allgemeineFunktionen.kommaInPunkt(e))
            .then((res) => {
              if (res["LastGesetzt"] === false) {
                this.zeigeFehler(
                  "Load not possible",
                  "The selected load is not available for this configuration.\nSettings will be reset.",
                  () => {
                    this.Last = aktuelleLast;
                    this.lastGesetzt = true;
                  }
                );
              } else {
                // baue neue HALaengen auf.
                this.haSelect_disabled = true;
                this.craneControlServiceSuper
                  .erzeugeNeueFilterListe({ RHLLast: e }, [])
                  .then((res1) => {
                    this.haSelect_disabled = false;
                    aktuelleLast = String(res["aktuelleLast"]);
                    res["HALaengen"] = res1["HALaengen"];
                    this.aktualisiereAnzeigeFelder(res);
                    this.lastGesetzt = true;
                  });
                this.pruefeAufKompatiblenTabellenKran();
              }
            });
        } else {
          this.lastGesetzt = true;
        }
      }, 100);
    }
  }
  berehnungAnschalten() {
    if (this.aendereWerte["berechnungAnschalten"] !== undefined) {
      clearTimeout(this.aendereWerte["lastberechnungAnschalten"]);
    }
    this.aendereWerte["berechnungAnschalten"] = setTimeout(() => {
      this.berechnungAn = false;
      this.craneControlServiceSuper.minMAXan(true).then(() => {
        this.berechnungAn = true;
      });
    }, 100);
  }
  radiusAendern(e: string) {
    if (this.aendereWerte["radiusAendern"] !== undefined) {
      clearTimeout(this.aendereWerte["radiusAendern"]);
    }
    e = allgemeineFunktionen.kommaInPunkt(e);
    if (isNaN(Number(e))) {
      this.zeigeFehler(
        "Incorrect value",
        "The value entered is not at number, please enter a number value.",
        () => {
          this.formRadiusInput.nativeElement.value = this.Radius;
        }
      );
    } else {
      this.aendereWerte["radiusAendern"] = setTimeout(() => {
        this.radiusGesetzt = false;
        if (e === "") {
          e = String(this.Radius);
          this.Radius = e;
        }
        if (parseFloat(e) !== parseFloat(this.Radius)) {
          this.aktualisiereAnzeige = true;
          this.craneControlServiceSuper.aendereRadius(e).then((res) => {
            if (res["RadiusGesetzt"] === false) {
              this.zeigeFehler(
                "Radius not possible",
                "The selected radius is not available for this configuration. Settings will be reset.",
                () => {
                  this.Radius = String(res["Radius"]);
                }
              );
            }
            // baue neue HALaengen auf.
            //              this.haSelect_disabled = true;
            //              this.craneControlServiceSuper.erzeugeNeueFilterListe({}, []).then(
            //                res1 => {
            //                  this.haSelect_disabled = false;
            //                  res['HALaengen'] = res1['HALaengen'];
            //                  this.aktualisiereAnzeigeFelder(res);
            //                  this.lastMarkerSetzen();
            //                  this.radiusGesetzt = true;
            //                });
            this.aktualisiereAnzeigeFelder(res);
            this.lastMarkerSetzen();
            this.radiusGesetzt = true;
            this.pruefeAufKompatiblenTabellenKran();
          });
        } else {
          this.radiusGesetzt = true;
        }
      }, 100);
    }
  }
  lastMarkerSetzen() {
    const radius: number =
      (this.maxVersatz * parseFloat(this.Radius)) / this.maxRadius;
    const winkel: number = allgemeineFunktionen.deg2rad(
      parseFloat(this.OWWinkel) - 90
    );
    const x: number = Math.cos(winkel) * radius;
    const y: number = Math.sin(winkel) * radius;
    this.translate = "translate(" + x + "px," + y + "px)";
    this.AuslegerStrichLaenge = radius + "px";
    const anzeigeWinkel = (parseFloat(this.OWWinkel) - 90).toString();
    this.AuslegerStrichRotation = "rotate(" + anzeigeWinkel + "deg)";
  }
  haLaengeAendern(e: string) {
    sessionStorage.setItem("haAusfahrfolgeGewaehlt", "false");
    this.HAWerteFuerNeueHALaenge = {};
    if (
      this.passendeHAAusfahrfolgen[
        this.rundeHAWerte(e, this.stellenNachEinheitenSystem)
      ].length === 1
    ) {
      this.HAWerteFuerNeueHALaenge["HALaenge"] = e;
      sessionStorage.setItem(
        "haAusfahrfolge",
        this.passendeHAAusfahrfolgen[
          this.rundeHAWerte(e, this.stellenNachEinheitenSystem)
        ][0]
      );
      sessionStorage.setItem("haAusfahrfolgeGewaehlt", "true");
    } else {
      let meldung =
        "<p>" +
        "Choosen boom length could be reached with different boom sequences.+" +
        "<br />";
      meldung += "Please choose one" + ":";
      meldung += "</p><form><fieldset>";
      let z = 0;
      for (const wert of this.passendeHAAusfahrfolgen[
        this.rundeHAWerte(e, this.stellenNachEinheitenSystem)
      ]) {
        z++;
        if (z === 1) {
          sessionStorage.setItem("haAusfahrfolge", wert);
        }
        meldung +=
          "<span onClick=\"sessionStorage.setItem('haAusfahrfolge', '" +
          wert +
          "');\">";
        meldung +=
          '<input type="radio" id="' +
          wert +
          '" value="' +
          wert +
          '" id="HAAusfahrfolgenauswahl" name="HAAusfahrfolgenauswahl"';
        meldung += (z === 1 ? " checked" : "") + ">";
        meldung += ' <label for="' + wert + '">' + wert + "</label>";
        meldung += "</span><br />";
      }
      meldung += "</fieldset></form>";
      meldung +=
        "<button onClick=\"sessionStorage.setItem('haAusfahrfolgeGewaehlt', true);\">Continue</button>";
      this.dialogHTML = this.sanitizerSuper.bypassSecurityTrustHtml(meldung);
      this.zeigeDialog = true;
    }
    this.haLaengeAendernWartenAufAusfahrfolge();
  }
  haLaengeAendernWartenAufAusfahrfolge() {
    if (sessionStorage.getItem("haAusfahrfolgeGewaehlt") === "true") {
      this.zeigeDialog = false;
      this.HAWerteFuerNeueHALaenge["HAausfahrf"] =
        sessionStorage.getItem("haAusfahrfolge");
      this.haLaengeAendernAusfuehren();
      sessionStorage.removeItem("haAusfahrfolgeGewaehlt");
      sessionStorage.removeItem("haAusfahrfolge");
    } else {
      setTimeout(() => this.haLaengeAendernWartenAufAusfahrfolge(), 200);
    }
  }

  haLaengeAendernAusfuehren(): Promise<any> {
    this.aktualisiereAnzeige = true;
    // pruefen ob mehrere HAAusfahrfolgen möglich sind?
    return this.craneControlServiceSuper
      .aendereHALaenge(this.HAWerteFuerNeueHALaenge)
      .then((res) => {
        this.aktualisiereAnzeige = true;
        this.appStateServiceSuper.appStatusVonServerHolen().then((res1) => {
          this.aktualisiereAnzeigeFelder(res);
          this.pruefeAufKompatiblenTabellenKran();
        });
      });
  }
  gegengewichtAendern(e: string) {
    this.aktualisiereAnzeige = true;
    this.craneControlServiceSuper
      .aendereGegengewicht(e)
      .then((res) => this.aktualisiereAnzeigeFelder(res));
  }
  haWinkelAendern(e: string) {
    if (this.aendereWerte["haWinkelAendern"] !== undefined) {
      clearTimeout(this.aendereWerte["haWinkelAendern"]);
    }
    e = allgemeineFunktionen.kommaInPunkt(e);
    if (isNaN(Number(e))) {
      this.zeigeFehler(
        "Incorrect value",
        "The value entered is not at number, please enter a number value.",
        () => {
          this.formHAWinkelInput.nativeElement.value = this.HAWinkel;
        }
      );
    } else {
      this.aendereWerte["haWinkelAendern"] = setTimeout(() => {
        if (e === "") {
          e = String(this.HAWinkel);
          this.HAWinkel = e;
        }
        if (parseFloat(e) !== parseFloat(this.HAWinkel)) {
          this.aktualisiereAnzeige = true;
          this.craneControlServiceSuper.aendereHAWinkel(e).then((res) => {
            if (res["gewippt"] === false) {
              this.zeigeFehler(
                "Angle not possible",
                "The selected angle is not available for this configuration.\nSettings will be reset.",
                () => {
                  this.HAWinkel = String(res["HAWinkel"]);
                }
              );
            }
            this.aktualisiereAnzeigeFelder(res);
            this.lastMarkerSetzen();
            this.pruefeAufKompatiblenTabellenKran();
          });
        }
      }, 100);
    }
  }
  setzeBeschreibung(e: any) {
    if (this.aendereWerte["setzeBeschreibung"] !== undefined) {
      clearTimeout(this.aendereWerte["setzeBeschreibung"]);
    }
    this.aendereWerte["setzeBeschreibung"] = setTimeout(() => {
      this.description = e.target.value;
      this.appStateServiceSuper.appStatusSetzen({
        KurzBeschreibung: e.target.value,
      });
    }, 100);
  }
  bitteWarten() {
    return (
      this.ladeKran ||
      this.aktualisiereAnzeige ||
      this.ergebnisseAktualisieren ||
      this.kranZustandAendern ||
      this.ruestdatenAktualisieren ||
      this.MAXWerteAktualisieren ||
      this.haSelect_disabled ||
      !this.radiusGesetzt ||
      !this.lastGesetzt ||
      !this.owWinkelGesetzt ||
      this.initialisiereKran
    );
  }
  Print() {
    window.open("./LiftplanII/PDF/printout.php?");
  }
  /**
   * Die CraneControl soll von MAXbase auf 360° oder umgekehrt umgeschaltet werden
   */
  kranUmruesten() {
    sessionStorage.removeItem("changeControl");
    if (this.sichtbarkeitUmruestung === 1.0) {
      // Daten fuer Tabellenkran setzen
      this.kranUmruestenBestaetigen();
    }
  }
  kranUmruestenBestaetigen() {
    if (
      (allgemeineFunktionen.isset(this.kompatiblerKran["radiusHinweis"]) &&
        this.kompatiblerKran["radiusHinweis"] !== "") ||
      (allgemeineFunktionen.isset(this.kompatiblerKran["lastHinweis"]) &&
        this.kompatiblerKran["lastHinweis"] !== "")
    ) {
      let meldung = "<p><h1>" + "Attention" + "</h1><br />";
      meldung +=
        "It seems there is a compatible database for this crane when changing to table based control." +
        "<br />";
      meldung += "But" + " ";
      const t = [];
      if (allgemeineFunktionen.isset(this.kompatiblerKran["lastHinweis"])) {
        t.push("load");
      }
      if (allgemeineFunktionen.isset(this.kompatiblerKran["radiusHinweis"])) {
        t.push("radius");
      }
      meldung +=
        t.join(" and ") +
        " " +
        "can not be set to the given values" +
        ".</p><p>";
      if (allgemeineFunktionen.isset(this.kompatiblerKran["lastHinweis"])) {
        meldung += this.kompatiblerKran["lastHinweis"] + "<br />";
      }
      if (allgemeineFunktionen.isset(this.kompatiblerKran["radiusHinweis"])) {
        meldung += this.kompatiblerKran["radiusHinweis"] + "<br />";
      }
      if (allgemeineFunktionen.isset(this.kompatiblerKran["lastHinweis"])) {
        meldung +=
          "load will be set to" +
          " " +
          this.kompatiblerKran["lastZuSetzen"] +
          this.gewichtsEinheit;
      }
      if (allgemeineFunktionen.isset(this.kompatiblerKran["radiusHinweis"])) {
        meldung +=
          "radius will be set to" +
          " " +
          this.kompatiblerKran["radiusZuSetzen"] +
          this.laengenEinheit;
      }
      meldung += "</p>";
      meldung +=
        "<button onClick=\"sessionStorage.setItem('changeControl', 'continue');\">Continue</button>";
      meldung +=
        "&nbsp;<button onClick=\"sessionStorage.setItem('changeControl', 'cancel');\">Cancel</button>";
      this.dialogHTML = this.sanitizerSuper.bypassSecurityTrustHtml(meldung);
      this.zeigeDialog = true;
      sessionStorage.setItem("changeControl", "unknown");
    } else {
      sessionStorage.setItem("changeControl", "continue");
    }
    this.warteAufUmruestbestaetigung();
  }
  warteAufUmruestbestaetigung() {
    if (
      allgemeineFunktionen.isset(sessionStorage.getItem("changeControl")) &&
      (sessionStorage.getItem("changeControl") === "continue" ||
        sessionStorage.getItem("changeControl") === "cancel")
    ) {
      this.zeigeDialog = false;
      if (sessionStorage.getItem("changeControl") === "continue") {
        this.appStateServiceSuper.appStatusSetzen({
          kranDatenbankNamen: this.kompatiblerKran["dbName"],
          kranname: this.kompatiblerKran["kranname"],
          kranBerechnungsArt: this.kompatiblerKran["berechnungsArt"],
          pointer: this.kompatiblerKran["pointer"],
          CraneSetupMenu:
            this.appStateServiceSuper.aktuellerAppStatus["CraneSetupMenu"] ===
            "standardTabellenSetup"
              ? "maxBaseSetup"
              : "standardTabellenSetup",
          CraneControlMenu:
            this.appStateServiceSuper.aktuellerAppStatus["CraneControlMenu"] ===
            "control360Table"
              ? "controlMaxBase"
              : "control360Table",
          RHLRadius: this.kompatiblerKran["radiusZuSetzen"],
          RHLLast: this.kompatiblerKran["lastZuSetzen"],
          abstuetzVarianten: this.kompatiblerKran["abstuetzVarianten"],
          anzahlAbstuetzPositionen:
            this.appStateServiceSuper.aktuellerAppStatus["maxStuetzenPosition"],
          abstuetzMuster:
            "" +
            this.appStateServiceSuper.aktuellerAppStatus["stuetzenPositionVL"] +
            this.appStateServiceSuper.aktuellerAppStatus["stuetzenPositionVL"] +
            this.appStateServiceSuper.aktuellerAppStatus["stuetzenPositionVL"] +
            this.appStateServiceSuper.aktuellerAppStatus["stuetzenPositionVL"],
          seitenSpiegeln: false,
          abstuetzVerteilung: "VH",
        });
        setTimeout(() => {
          if (this.routerSuper.url === "/control360Table") {
            this.routerSuper.navigate(["controlMaxBase"]);
          } else if (this.routerSuper.url === "/controlMaxBase") {
            this.routerSuper.navigate(["control360Table"]);
          }
        }, 200);
      } else {
        // Dann machen wir wohl nichts
      }
    } else {
      setTimeout(() => this.warteAufUmruestbestaetigung(), 200);
    }
  }
  /**
   * Sucht nach einem kompatiblen Kran. Derzeit nur für MAXBase -> Tabellen
   */
  pruefeAufKompatiblenTabellenKran() {
    // schauen ob der Kran MAXBase oder 360° ist. Ansonsten ist uns das im Moment noch egal ...
    if (
      this.appStateServiceSuper.aktuellerAppStatus["kranBerechnungsArt"] !==
        "2" &&
      this.appStateServiceSuper.aktuellerAppStatus["kranBerechnungsArt"] !== "0"
    ) {
      this.sichtbarkeitUmruestung = 0.0;
      this.UmruestenTooltip = "only for MAXBase or 360°";
      return;
    }
    // schauen ob der Kran symmetrisch ist
    if (
      !(
        this.appStateServiceSuper.aktuellerAppStatus["abstuetzProzenteVL"] ===
          this.appStateServiceSuper.aktuellerAppStatus["abstuetzProzenteVR"] &&
        this.appStateServiceSuper.aktuellerAppStatus["abstuetzProzenteVL"] ===
          this.appStateServiceSuper.aktuellerAppStatus["abstuetzProzenteHL"] &&
        this.appStateServiceSuper.aktuellerAppStatus["abstuetzProzenteVL"] ===
          this.appStateServiceSuper.aktuellerAppStatus["abstuetzProzenteHR"]
      )
    ) {
      this.UmruestenTooltip = "Not possible for asymmetric outrigger base.";
      this.sichtbarkeitUmruestung = 0.5;
      return;
    }
    // Prüfen ob wir eine passende DB haben und es auch noch einen passenden Rüstzustand gibt
    this.craneControlServiceSuper.pruefeAufKompatiblenKran().then((res) => {
      if (res["gefunden"] === false) {
        this.UmruestenTooltip = "No compatible database available";
        this.sichtbarkeitUmruestung = 0.5;
      } else {
        this.kompatiblerKran = {
          kranname: res["Krannamen"],
          dbName: res["Datenbanknamen"],
          pointer: res["Pointer"],
          berechnungsArt: res["Berechnungsart"],
          lastSetzbar: res["lastGesetzt"],
          lastZuSetzen: res["lastZuSetzen"],
          radiusZuSetzen: res["radiusZuSetzen"],
          abstuetzVarianten: res["abstuetzVarianten"],
        };
        if (allgemeineFunktionen.isset(res["lastHinweis"])) {
          this.kompatiblerKran["lastHinweis"] = res["lastHinweis"];
        }
        if (allgemeineFunktionen.isset(res["radiusHinweis"])) {
          this.kompatiblerKran["radiusHinweis"] = res["radiusHinweis"];
        }
        if (res["Berechnungsart"] === "0") {
          this.UmruestenTooltip = "Go to table based control";
        } else if (res["Berechnungsart"] === "2") {
          this.UmruestenTooltip = "Go to MAXBase control";
        }
        this.sichtbarkeitUmruestung = 1.0;
      }
    });
  }
  zeigeFehler(Ueberschrift: string, Hinweis: string, callback: Function) {
    this.zeigeFehlerMeldung = true;
    this.FehlerUeberschrift = Ueberschrift;
    this.FehlerHinweis = Hinweis;
    this.FehlerCallback = callback;
  }

  rundeHAWerte(Zahl: string, Stellen: number = 2) {
    if (Zahl === "") {
      return "";
    }
    return allgemeineFunktionen.rundeZahl(parseFloat(Zahl), Stellen);
  }
}
